// PropDesk - Seed / Constants
// SEED_PROPERTIES, SEED_USERS etc are no longer used for data
// (all data comes from Supabase) but kept for reference and fallback.
// CATEGORIES, PRIORITY_STYLES, STATUS_STYLES, TRADES are used throughout the app.

export const SEED_PROPERTIES = [
  { id: 1, companyId: 1, name: "3477 E 48th Ave", address: "3477 E 48th Ave, Vancouver, BC", street: "3477 E 48th Ave", city: "Vancouver", province: "BC", units: 6, image: "building", regCode: "PROP-4801" },
  { id: 2, companyId: 1, name: "3479 E 48th Ave", address: "3479 E 48th Ave, Vancouver, BC", street: "3479 E 48th Ave", city: "Vancouver", province: "BC", units: 6, image: "building", regCode: "PROP-4802" },
  { id: 3, companyId: 1, name: "3416 E 4th Ave",  address: "3416 E 4th Ave, Vancouver, BC",  street: "3416 E 4th Ave",  city: "Vancouver", province: "BC", units: 8, image: "building", regCode: "PROP-4003" },
];

export const SEED_CONTRACTORS = [
  { id: 1, companyId: 1, name: "Mike Thompson", trade: "Plumbing",   email: "mike@fixitplumbing.ca",   phone: "604-555-0101", totalPaid: 0 },
  { id: 2, companyId: 1, name: "Carlos Rivera", trade: "Electrical", email: "carlos@sparkelectric.ca", phone: "604-555-0202", totalPaid: 0 },
  { id: 3, companyId: 1, name: "Anna Kowalski", trade: "HVAC",       email: "anna@coolhvac.ca",        phone: "604-555-0303", totalPaid: 0 },
  { id: 4, companyId: 1, name: "Dev Patel",     trade: "General",    email: "dev@handy.ca",            phone: "604-555-0404", totalPaid: 0 },
];

export const SEED_TICKETS   = [];
export const SEED_USERS     = [];
export const SEED_PAYMENTS  = [];

export const CATEGORIES = [
  // Unit maintenance
  "Plumbing", "Electrical", "HVAC", "Appliance", "Structural",
  // Safety & health
  "Security", "Pest Control", "Health & Safety",
  // Common area / neighbour issues
  "Noise / Disturbance", "Garbage & Recycling", "Common Area", "Smoking",
  // Other
  "Other",
];

export const PRIORITY_STYLES = {
  CRITICAL: { bg: "#FF2D2D22", text: "#FF2D2D", label: "Critical" },
  HIGH:     { bg: "#FF7A2222", text: "#FF7A22", label: "High"     },
  MEDIUM:   { bg: "#F5C84222", text: "#C49500", label: "Medium"   },
  LOW:      { bg: "#22AA5522", text: "#22AA55", label: "Low"      },
};

export const STATUS_STYLES = {
  OPEN:        { bg: "#FF2D2D18", text: "#FF2D2D", label: "Open"        },
  IN_PROGRESS: { bg: "#2A7BE818", text: "#2A7BE8", label: "In Progress" },
  RESOLVED:    { bg: "#22AA5518", text: "#22AA55", label: "Resolved"    },
};

export const TRADES = [
  "Plumbing", "Electrical", "HVAC", "Appliance",
  "Carpentry", "Painting", "Pest Control", "General", "Other",
];

// Tax rates -- update here when CRA changes rates
export const GST_RATE    = 0.05; // 5% Federal GST
export const BC_PST_RATE = 0.07; // 7% BC PST (not applied to most services)

export const CANADIAN_PROVINCES = [
  "AB", "BC", "MB", "NB", "NL", "NS", "NT", "NU", "ON", "PE", "QC", "SK", "YT",
];
